<template>
  <b-form-group
    label-for="keberadaan"
    label="Keberadaan"
  >
    <b-form-radio
      v-model="keberadaan"
      value="1"
      disabled
    > Ada </b-form-radio>
    <b-col
      v-if="keberadaan == 1"
      cols="11"
      offset-md="1"
      class="mt-1"
    >
      <b-form-group
        label-for="tandaBatas"
        label="Tanda Batas"
      >
        <b-form-group
          label-for="barat"
          label="Barat"
        >
          <slot name="barat" />
        </b-form-group>
        <b-form-group
          label-for="utara"
          label="Utara"
        >
          <slot name="utara" />
        </b-form-group>
        <b-form-group
          label-for="selatan"
          label="Selatan"
        >
          <slot name="selatan" />
        </b-form-group>
        <b-form-group
          label-for="timur"
          label="Timur"
        >
          <slot name="timur" />
        </b-form-group>
      </b-form-group>

      <b-form-group
        label-for="keteranganBeton"
        label="Keterangan Beton"
      >
        <b-form-radio
          v-model="keteranganBeton"
          value="1"
          disabled
        >
          Beton
        </b-form-radio>
        <b-form-radio
          v-model="keteranganBeton"
          value="0"
          disabled
        >
          Bukan Beton
        </b-form-radio>

        <b-col
          v-if="keteranganBeton == '0'"
          cols="11"
          offset-md="1"
          class="mt-1"
        >
          <b-form-group
            label-for="keteranganBetonSebutkan"
            label="Sebutkan"
          >
            <slot name="keteranganBetonSebutkan" />
          </b-form-group>
        </b-col>
      </b-form-group>
      <b-form-group
        label-for="peruntukkanPenggunaanBmd"
        label="Peruntukkan Penggunaan BMD"
      >
        <slot name="peruntukkanPenggunaanBmd" />
      </b-form-group>
    </b-col>
    <b-form-radio
      v-model="keberadaan"
      value="0"
      disabled
    >
      Tidak Ada
    </b-form-radio>
    <b-col
      v-if="keberadaan == '0'"
      cols="11"
      offset-md="1"
      class="mt-1"
    >
      <b-form-group
        label-for="alasanTidakAdaBarang"
        label="Apakah Merupakan Biaya-Biaya/Beban"
      >
        <b-form-radio
          v-model="biaya2beban"
          value="0"
          disabled
        >
          Fisik Tidak Ditemukan
        </b-form-radio>

        <b-col
          v-if="biaya2beban == '0'"
          cols="11"
          offset-md="1"
          class="mt-1"
        >
          <b-form-group
            label-for="alasanTidakAdaBarang"
            label="Alasan Tidak Ada Barang"
          >
            <b-form-radio
              v-model="alasanTidakAdaBarang"
              value="0"
              disabled
            >
              Transfer Antar PD/UKPD
            </b-form-radio>
            <b-form-radio
              v-model="alasanTidakAdaBarang"
              value="1"
              disabled
            >
              Sudah Dibongkar Tanpa SK dan Belum Dihapus
            </b-form-radio>
            <b-form-radio
              v-model="alasanTidakAdaBarang"
              value="2"
              disabled
            >
              Hilang
            </b-form-radio>
            <b-form-radio
              v-model="alasanTidakAdaBarang"
              value="3"
              disabled
            >
              Sebab Lain
            </b-form-radio>
            <b-col
              v-if="alasanTidakAdaBarang == '3'"
              cols="11"
              offset-md="1"
              class="mt-1"
            >
              <b-form-radio
                v-model="sebabLain"
                value="10"
                disabled
              >
                Hilang Karena Kecurian
              </b-form-radio>
              <b-form-radio
                v-model="sebabLain"
                value="9"
                disabled
              >
                Terbakar
              </b-form-radio>
              <b-form-radio
                v-model="sebabLain"
                value="8"
                disabled
              >
                Susut
              </b-form-radio>
              <b-form-radio
                v-model="sebabLain"
                value="7"
                disabled
              >
                Tenggelam/Amblas/Longsor
              </b-form-radio>
              <b-form-radio
                v-model="sebabLain"
                value="6"
                disabled
              >
                Kejadian Kahar (Force Majeure)
              </b-form-radio>
              <b-form-radio
                v-model="sebabLain"
                value="5"
                disabled
              >
                Sebab Lainnya
              </b-form-radio>

              <b-col
                v-if="sebabLain == '5'"
                cols="11"
                offset-md="1"
                class="mt-1"
              >
                <slot name="sebabLain" />
              </b-col>
            </b-col>
          </b-form-group>
        </b-col>

        <b-form-radio
          v-model="biaya2beban"
          value="1"
          disabled
        >
          Non Fisik/Biaya-Biaya
        </b-form-radio>
      </b-form-group>
    </b-col>
  </b-form-group>
</template>
<script>
export default {
  props: {
    keberadaan: { type: String, default: '' },
    keteranganBeton: { type: String, default: '' },
    biaya2beban: { type: String, default: '' },
    alasanTidakAdaBarang: { type: String, default: '' },
    sebabLain: { type: String, default: '' },
  },
}
</script>
